
<mat-card>
    <mat-card-header>
        <mat-card-title>Google play</mat-card-title>
        <mat-card-subtitle>
            <a href="https://play.google.com/store/apps/details?id=com.yardhostle">Play Store</a>
        </mat-card-subtitle>
    </mat-card-header>
<!--
    <mat-card-header>
        <mat-card-title>Android download</mat-card-title>
        <mat-card-subtitle>
             <a href="https://drive.google.com/file/d/1ZChX2vzTPspbLaT-qrWAm5n9bWhRZJxy/view?usp=drive_link" download="your-app-name.apk">
            Download APK
          </a>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <section class="instructions-holder">
            <span>Installation instructions</span>
             <a href="https://www.expressvpn.com/support/vpn-setup/enable-apk-installs-android/" target="_blank">Install APK Instructions</a>
        </section>
       <section class="video-holder">
        <p>Video Instructions</p>
            <iframe class="iframe-holder" src="https://www.youtube.com/embed/N0M4XGkpCn4?si=a7l16eRRwFDrwONl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
       </section>
    </mat-card-content>
-->
</mat-card>